import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Paper, Typography } from '@mui/material';
import { MainLayoutSVG } from '../assets/MainLayoutSVG';

export const MainLayout = () => {
    const styles = {
        wrapper: {
            backgroundColor: '#E6E6EC',
            display: 'flex',
            justifyContent: 'center',
            height: '100vh',
            margin: -1,
        },
        content: {
            padding: '1em',
        },
    };

    return (
        <Box sx={styles.wrapper}>
            <Box sx={styles.content}>
                <Paper
                    sx={{
                        p: 2,
                        pt: 4,
                        width: { xs: '80vw', sm: '70vw', md: '70vw' },
                        position: 'relative',
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: 5,
                        minHeight: '90vh',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexDirection: 'column',
                            paddingBottom: 9,
                            paddingTop: 6,
                        }}
                    >
                        <Box display="flex" flexDirection="column">
                            <Typography
                                textAlign="center"
                                variant="h3"
                                fontWeight={500}
                            >
                                Consulta de
                            </Typography>
                            <Typography
                                textAlign="center"
                                variant="h3"
                                color="primary"
                                fontWeight={500}
                            >
                                BC Score
                            </Typography>
                        </Box>
                        <MainLayoutSVG width={350} />
                    </Box>
                    <Outlet />
                </Paper>
            </Box>
        </Box>
    );
};
